export const environment = {
  // apiUrl: 'https://app.bajakudlutemple.com/api',
  // apiUrl: 'http://54.83.109.146:3000',
  // apiUrl: 'http://95.111.240.120:84/temple/api',
  apiUrl: 'https://app.bajakudlutemple.com/api',

  production: false,
};
